<template>
  <div :class="[{ 'not-found-layout': transactions.length === 0 }]">
    <md-table
      class="history-table"
      v-model="transactions"
      md-sort="date"
      md-sort-order="asc"
      md-card
      md-fixed-header
      v-if="transactions.length > 0"
    >
      <md-table-row slot="md-table-row" slot-scope="{ item }">
        <md-table-cell md-label="Type">
            {{ item.Type }}
        </md-table-cell>
        <md-table-cell md-label="Action" @click="goToPage(item)">
          {{ actionText(item) }}
          <router-link v-if="whenToRoute(item)" :to="`/s-app/profile-page/${item.Partner_id}`" class="router-text">{{ item.Partner }}</router-link >
        </md-table-cell>
        <md-table-cell class="history-date" md-label="Date" md-sort-by="Date">{{
          _formatDate(item.Date)
        }}</md-table-cell>
        <md-table-cell
          :class="{
            'history-earned': item.Trade === 'Earned',
            'history-spent': item.Trade === 'Spent',
          }"
          md-label="Amount"
          md-sort-by="Amount"
          >{{ _formatPoints(item) }}</md-table-cell
        >
        <md-table-cell class="history-total" md-label="Total" md-numeric>
          <div class="history-total-points">
            {{formatPoints(item.Total)}}
          </div>
        </md-table-cell>
      </md-table-row>
    </md-table>
    <div class="not-found-cont" v-else>
      <div class="not-found" >
        <span>No transaction were found in your history</span>
      <hr />
    </div>
    </div>

  </div>
</template>

<script>

import moment from "moment";
import PointsHelperVue from "@/mixins/PointsHelper.vue";
import ItemHelperVue from "@/mixins/ItemHelper.vue";
export default {
  name: "PointsHistoryTable",
  mixins: [PointsHelperVue, ItemHelperVue],
  props: ["transactions"],
  methods: {
    _formatDate(date) {
      return moment(new Date(date)).format("MM/DD/YYYY");
    },
    _formatPoints(item) {
      const amount = this.formatPoints(item.Amount);
      if(item.Trade === "Earned") {
        return "+"+amount;
      }
      return amount;
    },
    actionText(item) {
      let firstChar = item.Note.indexOf(">");
      let secondChar = item.Note.lastIndexOf("<");
      if (item.Note.includes("send"))
        if ((item.Trade === "Earned"))
          return (`Points received from `)
        else
          return (`Points sent to `)
      else if (item.Note.includes("garage"))
        return (`${item.Note}`)
      else if (item.Note.includes("added"))
        return (`You added ${item.Note.slice(firstChar+1,secondChar)}`)
      else if (item.Note.includes("trade") && (item.Trade === "Spent"))
        return (`You sent points for ${item.Note.slice(firstChar+1,secondChar)}`)
      else if (item.Note.includes("trade") && (item.Trade === "Earned"))
        return (`You received points for ${item.Note.slice(firstChar+1,secondChar)}`)
      else if (item.Note.includes("default"))
        return ("First garage sale added")
      return item.Note
    },
    whenToRoute(item) {
      if (item.Note.includes("send"))
        return true;
      return false;

    },
  },
};
</script>

<style lang="scss" scoped>
.item-img {
  max-width: fit-content;
  width: 40px !important;
}
.history-date, .history-spent {
  color: $dark;
}
.history-earned {
  color: $primary;
}
.history-total {
  color: $black;
}

.history-total-points {
  margin-left: 25px;
}
.history-total, .history-earned, .history-spent {
  font-weight: bold;
  font-size: 14px;
  white-space: nowrap;
  text-align: center;
}
.not-found {
  margin-top: 2rem;
  color: $black;
  font-weight: 500;
  align-self: center;
}
.not-found-layout {
  justify-content: center;
}
.not-found-cont {
  display: flex;
  justify-content: center;
  align-items: center;
}
.router-text {
  color: $primary;
}
</style>

<style lang="scss">
.md-table table {
  margin-left: -0.8rem;
}
.md-table-head-label {
  color: #000000;
}
.history-table {
  box-shadow: unset;
}
.md-table-head {
  width: 19%;
}

.md-table-cell-container {
  padding: 0.75rem 1rem;
}
</style>
